import styled, {
  LargeTextInput,
  Scale,
  TypographyVariant,
  typographyVariantProperties,
} from '@secretescapes/falcon';

export const Inputs = styled('div')`
  display: flex;
`;

interface StyledLargeTextInputProps {
  removeBorder?: 'left' | 'right';
}

export const StyledLargeTextInput = styled(LargeTextInput)<StyledLargeTextInputProps>`
  ${({ removeBorder }) => removeBorder && `border-${removeBorder}: 0 !important;`};
  padding: ${Scale.s} ${Scale.m} !important;

  &:focus,
  &:focus-within {
    > div > input {
      font-size: ${typographyVariantProperties[TypographyVariant.b2].desktopFontSize} !important;
    }
  }
`;
